import React from 'react';
import { injectIntl } from 'react-intl';

import PropTypes from 'prop-types';
import {
    Bar,
    BarChart,
    CartesianGrid,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis,
} from 'recharts';

import ChartCard from '~/components/ChartCard';
import LocaleMessage from '~/components/LocaleMessage';

import { ChatCardContainer } from '../../Dashboard/styles';

function formatM2(value) {
    if (value == null || Number.isNaN(Number(value))) return '—';
    return `${Number(value).toFixed(2)} m²`;
}

function CleaningReportAreaByHourCard({ barColor, data, intl }) {
    const tooltipAreaLabel = intl.formatMessage({
        id: 'page.robots.cleaning_report.area_by_hour_tooltip_series',
    });

    return (
        <div className="row card-row">
            <div className="col-12 mb-5 dash-card">
                <ChatCardContainer>
                    <ChartCard
                        className="animated slideInFromLeft animation-duration-3"
                        title={
                            <LocaleMessage msg="page.robots.cleaning_report.area_by_hour_title" />
                        }
                        desc={
                            <LocaleMessage msg="page.robots.cleaning_report.area_by_hour_subtitle" />
                        }
                        value=""
                    >
                        <div className="row">
                            <div className="col-12 mb-3 area-chart-container">
                                <ResponsiveContainer
                                    className="card-img-bottom overflow-hidden animated slideInFromLeft animation-duration-5"
                                    width="100%"
                                    height={340}
                                >
                                    <BarChart
                                        data={data}
                                        margin={{
                                            top: 24,
                                            right: 16,
                                            left: 8,
                                            bottom: 36,
                                        }}
                                    >
                                        <CartesianGrid vertical={false} />
                                        <XAxis
                                            dataKey="label"
                                            interval={0}
                                            angle={-40}
                                            textAnchor="end"
                                            height={48}
                                            tick={{ fontSize: 10 }}
                                        />
                                        <YAxis
                                            tickFormatter={v =>
                                                `${Number(v).toFixed(0)}`
                                            }
                                            label={{
                                                value: 'm²',
                                                angle: -90,
                                                position: 'insideLeft',
                                            }}
                                        />
                                        <Tooltip
                                            formatter={v => [
                                                formatM2(v),
                                                tooltipAreaLabel,
                                            ]}
                                            labelFormatter={label => label}
                                        />
                                        <Bar
                                            dataKey="clean_area"
                                            fill={barColor}
                                            fillOpacity={0.88}
                                            radius={[4, 4, 0, 0]}
                                        />
                                    </BarChart>
                                </ResponsiveContainer>
                            </div>
                        </div>
                    </ChartCard>
                </ChatCardContainer>
            </div>
        </div>
    );
}

const areaByHourDatumPropType = PropTypes.shape({
    hour: PropTypes.number,
    label: PropTypes.string,
    clean_area: PropTypes.number,
});

CleaningReportAreaByHourCard.propTypes = {
    barColor: PropTypes.string.isRequired,
    data: PropTypes.arrayOf(areaByHourDatumPropType).isRequired,
};

export default injectIntl(CleaningReportAreaByHourCard);
